module.exports = __webpack_public_path__ + "media/אבוקדו.932056af.mp3";